import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppStateInterface } from 'src/app/stores/global/appState.interface';
import { currentEmployeeSelector } from 'src/app/stores/global/current-employee/current-employee.store';
import { TenantSettingsStoreService } from 'src/app/setting/tenant-settings/services/tenant-settings-store.service';

@Component({
    selector: 'app-my-time',
    templateUrl: './my-time.component.html',
    styleUrls: ['./my-time.component.css'],
    standalone: false
})
export class MyTimeComponent implements OnInit {

  constructor(
    private store: Store<AppStateInterface>,
    private tenantSettingsStore: TenantSettingsStoreService
  ) { }

  currentEmployee$ = this.store.select(currentEmployeeSelector);
  // The overtime balance row follows the tenant setting hasOvertime, like the report columns do.
  tenantSettings$ = this.tenantSettingsStore.tenantSettings$;

  ngOnInit(): void {
  }

}
